import { render, staticRenderFns } from "./DeletedList.vue?vue&type=template&id=579f3649&"
import script from "./DeletedList.vue?vue&type=script&lang=js&"
export * from "./DeletedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports